// O nome do time é gravado em minúsculas; na tela ele sai com as iniciais
// maiúsculas, como no cartão ao vivo da Visão geral. Só o do time: o nome da
// caixa é do jeito que o cliente escreveu ("WhatsApp da loja").
export const teamLabel = name =>
  (name || '').replace(
    /(^|\s)(\S)/g,
    (_, space, letter) => `${space}${letter.toLocaleUpperCase()}`
  );
